import { MutationCache, QueryClient } from '@tanstack/react-query';
import { toast } from '../components/ui/use-toast';
import { frenchErrorMessage } from './api/error-messages';

// Global safety net: any failed mutation surfaces a toast, unless the hook
// declares its own onError (which then owns the error UX).
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        if (mutation.options.onError !== undefined) return;
        toast({
          title: 'Erreur',
          description: frenchErrorMessage(error),
          variant: 'destructive',
        });
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // Surface failed fetches to the route ErrorBoundary instead of rendering
        // a misleading "empty" table.
        throwOnError: true,
      },
    },
  });
}
